import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

export function RevealOnScroll({ children, direction = "up", delay = 0 }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.15 });

  const variants = {
    hidden: {
      opacity: 0,
      y: direction === "up" ? 40 : direction === "down" ? -40 : 0,
      x: direction === "left" ? 40 : direction === "right" ? -40 : 0,
    },
    visible: { opacity: 1, y: 0, x: 0, transition: { duration: 0.7, delay, ease: [0.4, 0, 0.2, 1] } },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
    >
      {children}
    </motion.div>
  );
} 